import React, { FC, useState } from 'react'
import { Trans } from '@lingui/macro'
import { usePatchDraftMutation } from './operations/patchDraft.codegen'
import { useTopicForEditQuery } from 'front-end/src/pages/topic-edit-page/TopicEditPage'
import { TopicModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { videoAssessmentTopicVersionTypesForFE } from '../../StudentTopicDetail'
import {
  DrawerItem,
  DrawerItemHeader,
  Box,
  Flex,
  Input
} from 'front-end/src/components'
import IconCheck from '../../../../components/common/icon/IconCheck'
import { brandColors } from '../../../../../../shared/basicPalette'

export const SetVideoAssessmentPassMark: FC<{}> = () => {
  const { data, refetch: refetchTopic } = useTopicForEditQuery()
  const topic = data?.topic as TopicModelAsEditor

  const [passMark, setPassMark] = useState({
    value: topic?.draftVersion?.pass_mark ?? 0
  })

  const [patchDraft] = usePatchDraftMutation()
  const { draftVersion } = topic
  const isVideoAssessment =
    draftVersion?.topic_type &&
    videoAssessmentTopicVersionTypesForFE.includes(draftVersion?.topic_type)

  if (!isVideoAssessment) {
    return null
  }

  return (
    <DrawerItem isInline>
      <DrawerItemHeader mb={0}>
        <IconCheck />
        <Trans>Pass mark</Trans>
      </DrawerItemHeader>

      <Flex>
        <Box position="relative">
          <Input
            type="number"
            min="0"
            h="40px"
            w="90px"
            variant="filled"
            textAlign="center"
            pr="40px"
            max="100"
            value={passMark.value as number}
            onChange={async (e) => {
              const value = parseInt(e.target.value)
              try {
                setPassMark({
                  value
                })
                await patchDraft({
                  variables: {
                    topicId: topic.id,
                    input: {
                      pass_mark: value
                    }
                  }
                })
                refetchTopic()
              } catch (e) {
                setPassMark({
                  value: topic.draftVersion?.pass_mark ?? 0
                })
              }
            }}
          />
          <Box
            position="absolute"
            right="8px"
            top="8px"
            color={brandColors.grey.mid}
          >
            / 100
          </Box>
        </Box>
      </Flex>
    </DrawerItem>
  )
}
